
  var categoryScrollTo;
  window.addEventListener( "scroll", function () {
    // スクロール停止時にカテゴリ表示
	document.querySelector(".sidebar__current").classList.remove("is-active");
	clearTimeout( categoryScrollTo ); 

    categoryScrollTo = setTimeout( function () {
        document.querySelector(".sidebar__current").classList.add("is-active");
	}, 200 ) ;
　　// /スクロール停止時にカテゴリ表示

    // カレントカテゴリ表示
    const tut = document.querySelector(".TUTORS").getBoundingClientRect().top;
    const con = document.querySelector(".CONTENTS").getBoundingClientRect().top;
    const mes = document.querySelector(".MESSAGE").getBoundingClientRect().top;
    const inf = document.querySelector(".INFO").getBoundingClientRect().top;
    const navh = document.querySelector(".sidebar").clientHeight;
    const remove = document.querySelector(".sidebar__current-name.is-active").classList.remove("is-active");

    if (inf <= navh) {
      remove;
      document.querySelector(".category-info").classList.add("is-active");
    } else if (mes <= navh) {
      remove;
      document.querySelector(".category-message").classList.add("is-active");
    } else if (con <= navh) {
      remove;
      document.querySelector(".category-contents").classList.add("is-active");
    } else if (tut <= navh) {
      remove;
      document.querySelector(".category-tutors").classList.add("is-active");
    } else {
      remove;
      document.querySelector(".category-about").classList.add("is-active");
    }
    // /カレントカテゴリ表示
  });




document.addEventListener('DOMContentLoaded', function () {
    // 'menu-contents' クラスを持つすべての要素を取得
    const menuContentsElements = document.querySelectorAll('.menu-contents');

    // 'sidebar__menus' クラスを持つ要素を取得
    const sidebarMenusElements = document.querySelectorAll('.sidebar__menus');

    const sidebarMenusOverlayElements = document.querySelectorAll('.sidebar-overlay-background');

    const sidebarBodyElements = document.querySelectorAll('.template-index');

    // 各 'menu-contents' 要素に対してイベントリスナーを設定
    menuContentsElements.forEach(element => {
        element.addEventListener('click', () => {
            // 各 'sidebar__menus' 要素から 'opened' クラスを削除
            sidebarMenusElements.forEach(menu => {
                menu.classList.remove('opened');
            });
          
            sidebarMenusOverlayElements.forEach(menuover => {
                menuover.classList.remove('show');
            });

            sidebarBodyElements.forEach(body => {
                body.classList.remove('overflow-hidden');
            });
        });
    });
});
